import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setAgreedToTerms(checked);
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreedToTerms) {
      setErrorMessage('יש לאשר את תנאי השימוש ומדיניות הפרטיות.');
      return;
    }

    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await fetch('https://hook.eu2.make.com/2t459gwcwzl5ywtmjunkpke62g4hspg1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
          timestamp: new Date().toISOString(),
          source: 'contact-page'
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      // Reset form after successful submission
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: '',
      });
      
      // Show success message
      setSuccessMessage('תודה! הודעתך נשלחה בהצלחה.');
    } catch (err) {
      console.error('Error submitting form:', err);
      setErrorMessage('אירעה שגיאה בשליחת ההודעה. אנא נסה שוב מאוחר יותר.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container">
          <div className="header-content">
            <i className="fas fa-envelope"></i>
            <h1>צור קשר</h1>
          </div>
        </div>
      </div>

      <section className="contact-content">
        <div className="container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="info-section">
                <h2>פרטי התקשרות</h2>
                <div className="info-item">
                  <i className="fas fa-phone-alt"></i>
                  <div>
                    <h3>טלפון</h3>
                    <a href="tel:03-3820232">03-3820232</a>
                  </div>
                </div>
                <div className="info-item">
                  <i className="fas fa-envelope"></i>
                  <div>
                    <h3>דוא"ל</h3>
                    <a href="mailto:office@auto-cross.co.il">office@auto-cross.co.il</a>
                  </div>
                </div>
                <div className="info-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <h3>כתובת</h3>
                    <p>רחוב התמר 3, אבן יהודה</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <h2>רשתות חברתיות</h2>
                <div className="social-icons">
                  <a href="https://wa.me/97233820232" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=61575778435151" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/autocrossltd/" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <h2>שלחו לנו הודעה</h2>
              {successMessage && <div className="success-message">{successMessage}</div>}
              {errorMessage && <div className="error-message">{errorMessage}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">שם מלא</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required disabled={isSubmitting} />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">טלפון</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required disabled={isSubmitting} />
                </div>
                <div className="form-group">
                  <label htmlFor="email">דוא"ל</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={isSubmitting} />
                </div>
                <div className="form-group">
                  <label htmlFor="message">הודעה</label>
                  <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required disabled={isSubmitting}></textarea>
                </div>

                <div className="form-group terms-checkbox">
                  
                  <label htmlFor="terms-contact">
                    אני מאשר/ת את <a href="/terms" target="_blank" rel="noopener noreferrer">תנאי השימוש ומדיניות הפרטיות</a> ומסכים/ה לשמירת פרטיי ויצירת קשר.
                  </label>
                  <input 
                    type="checkbox" 
                    id="terms-contact"
                    name="terms"
                    checked={agreedToTerms}
                    onChange={handleChange}
                    required 
                    disabled={isSubmitting}
                  />
                </div>

                <button type="submit" className="submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'שולח...' : 'שלח הודעה' }
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 